import * as React from "react";
import { DailyVideoConsultationSettings } from "./VideoConsultationSettings";
import CodeWithCopyButton from "./CodeWithCopyButton";
import { LinkIcon } from "../commons/components/images/LinkIcon";

export default function DailyVideoConsultationPanel({
  roomUrl,
  meetingToken,
}: DailyVideoConsultationSettings) {
  const url = `${roomUrl}?t=${meetingToken}`;
  return (
    <div className={"video-consultation-daily-panel"}>
      <div className="h-flex">
        {i18n["Page.Settings.Customisation.VideoConsultation.Daily.Enabled.PatientLink.Info"]}
      </div>
      <CodeWithCopyButton text={roomUrl} icon={LinkIcon()} />
      <div className="h-flex align-center space-between with-margins start-panel">
        <div>
          <p>
            {i18n["Page.Settings.Customisation.VideoConsultation.Daily.Enabled.DoctorLink.Info"]}
          </p>
        </div>
        <a className="button-primary" target="_blank" href={url}>
          <i className="ic_video" />
          <span>
            {i18n["Page.Settings.Customisation.VideoConsultation.Daily.Enabled.DoctorLink.Start"]}
          </span>
        </a>
      </div>
      <div className="message warning">
        {i18n["Page.Settings.Customisation.VideoConsultation.Daily.Enabled.DoctorLink.Disclaimer"]}
      </div>
    </div>
  );
}
